import { render, staticRenderFns } from "./PopTerm2.vue?vue&type=template&id=8e494480&scoped=true&"
import script from "./PopTerm2.vue?vue&type=script&lang=js&"
export * from "./PopTerm2.vue?vue&type=script&lang=js&"
import style0 from "./PopTerm2.vue?vue&type=style&index=0&id=8e494480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e494480",
  null
  
)

export default component.exports